module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/checkbox-check-mark.f7237f0c.svg";